module.exports = __webpack_public_path__ + "static/media/introduce.6f327564.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程GLR增程式冷藏车/introduce.png
// module id = 704
// module chunks = 0